import { Bank } from 'client/Interfaces/Banking'
import { ExpensesOrder, ExpenseTransaction } from 'client/Interfaces/Expenses/ExpensesInterface'
import { l } from 'client/Other/Translation'
import moment from 'moment'
import React from 'react'

import Button, { ButtonType } from '../common/Button/Button'
import { MODAL_NAME } from './BankingModals/ConnectBankModal'

export const getTransactionSelectionsPeriods = (defaultValue: 30 | 60 | 89, selectedValue = null) => {
  const intervals = [30, 60, 89]
  return intervals.map((interval, index) => {
    const date = moment().subtract(interval, 'day')
    const startDate = moment(date)
    const endDate = moment()
    return {
      id: String(index),
      label: l(`bankingTransactionList.interval.${interval}.days`),
      selected: (!selectedValue && interval === defaultValue) || (selectedValue && selectedValue.id === index),
      value: {
        start: startDate.format('YYYY-MM-DD'),
        end: endDate.format('YYYY-MM-DD'),
        id: index,
      },
    }
  })
}

export const getDisplayName = (row) => {
  if (row?.creditor && row?.creditor?.name) {
    return row.creditor.name
  } else if (row?.name) {
    return row?.name
  } else if (row?.debtor && row?.debtor?.name) {
    return row?.debtor?.name
  } else {
    return row?.senderNameAddress || row?.id
  }
}

export const getVat = (row: ExpenseTransaction): number => {
  if (row?.vatBreakdowns.length > 0) {
    if (row?.vatBreakdowns && row?.vatBreakdowns?.length > 0) {
      return row?.vatBreakdowns?.reduce((acc, v) => acc + Number(v.grossTotal - v.netTotal), 0)
    }
  } else {
    if (row?.defaultVatPercentage && row?.transactionAmount?.amount) {
      return Number(
        (row?.transactionAmount?.amount * (row?.defaultVatPercentage / (1 + row?.defaultVatPercentage))).toFixed(2),
      )
    } else if (row?.defaultNetTotal && row?.transactionAmount?.amount) {
      return row?.transactionAmount?.amount - row.defaultNetTotal
    } else if (row?.defaultVatAmount) {
      return row?.defaultVatAmount
    }
  }
  return 0
}

export const checkNextOrderType = (orderType: ExpensesOrder, order) => {
  if (orderType !== order.orderBy && orderType === 'bookingdate') {
    return 'desc'
  } else if (orderType !== order.orderBy) {
    return 'asc'
  }
  return order.orderByType === 'desc' ? 'asc' : 'desc'
}

export const warningMessageForUser = (bank: Bank): JSX.Element => {
  return (
    <div className={`${MODAL_NAME}__warningMessageForUser`}>
      {l(`ConnectBankModal.warningMessageForUser.warningMessage.${bank.country}.${bank.name}`)}
      <Button
        label={l('ConnectBankModal.warningMessageForUsers.theirWebsite')}
        type={ButtonType.link}
        action={() => {
          window.open(l('ConnectBankModal.warningMessageForUsers.theirWebsite.link'), '_blank')
        }}
      />
    </div>
  )
}

export const getCategoryName = (row: ExpenseTransaction) => {
  if (row.category === null) {
    return '-'
  }
  return l(row.category)
}
